import { fetchApi } from 'api/fetch';

const cookiesGroup = {
	resetCookies: (hashId: string) =>
		fetchApi<readonly unknown[]>(`cookie/${hashId}`, {}, `PUT`),
};

export default cookiesGroup;
